import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ButtonModule } from '../shared/components/button/button.module';
import { DialogModule } from '../shared/components/dialog/dialog.module';
import { EmptyTableModule } from '../shared/components/empty-table/empty-table.module';
import { GenericTableModule } from '../shared/components/generic-table/generic-table.module';
import { SearchInputModule } from '../shared/components/search-input/search-input.module';
import { WarningDialogModule } from '../shared/components/warning-dialog/warning-dialog.module';
import { MessagesComponent } from './messages.component';

const routes = [
  {
    path: '', component: MessagesComponent,
  },
];

@NgModule({
  declarations: [MessagesComponent],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    SearchInputModule,
    GenericTableModule,
    ButtonModule,
    DialogModule,
    WarningDialogModule,
    EmptyTableModule
  ],
  exports : [MessagesComponent]
})
export class MessagesModule { }
